import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import { computed, defineComponent } from "@vue/composition-api";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useI18n } from "vue-i18n-composable";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
export default defineComponent({
  name: "GoalPropertySection",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    NotificationPopover
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      currentFlow,
      purchasePrice,
      formattedAddress,
      propertyHasCompleteAddress,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      t
    } = useI18n();
    const {
      PROPERTY_REQUESTED,
      IS_FILL_OUT,
      MORTGAGE_DETAILS_REQUESTED
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.PROPERTY_REQUESTED, ApplicationStandaloneGetters.IS_FILL_OUT, ApplicationStandaloneGetters.MORTGAGE_DETAILS_REQUESTED]);
    const isPreApprovalFlow = computed(() => currentFlow.value === APPLICATION_FLOW.PRE_APPROVAL);
    const isPurchaseFlow = computed(() => currentFlow.value === APPLICATION_FLOW.PURCHASE);
    const showPurchasePrice = computed(() => (PROPERTY_REQUESTED.value || !IS_FILL_OUT.value && _parseFloat(purchasePrice.value) !== 0) && (currentFlow.value === APPLICATION_FLOW.PURCHASE || isPreApprovalFlow.value));
    const goal = computed(() => {
      if (isPurchaseFlow.value) return t("application-standalone.labels.toPurchase");
      return isPreApprovalFlow.value ? t(`application-standalone.labels.pre-approve`) : t(`application-flow.flows.${currentFlow.value}`);
    });
    const addressTitle = computed(() => {
      const path = isPreApprovalFlow.value ? "application-standalone.pages.submit.provinceOfPropertyYouWishTo" : "application-standalone.pages.submit.addressOfPropertyYouWishTo";
      return t(path, {
        goal: goal.value.toString().toLowerCase()
      });
    });
    const noAddressSubtitle = computed(() => {
      const path = isPreApprovalFlow.value ? "application-standalone.pages.submit.pleaseAddProvince" : "application-standalone.pages.submit.pleaseAddPropertyAddress";
      return t(path, {
        goal: goal.value.toString().toLowerCase()
      });
    });
    const showGoalSection = computed(() => !IS_FILL_OUT.value || MORTGAGE_DETAILS_REQUESTED.value);
    const showPropertySection = computed(() => PROPERTY_REQUESTED.value || !IS_FILL_OUT.value && formattedAddress.value);
    return {
      purchasePrice,
      formattedAddress,
      propertyHasCompleteAddress,
      showPurchasePrice,
      goal,
      addressTitle,
      noAddressSubtitle,
      editButtonText,
      allowEdit,
      PROPERTY_REQUESTED,
      showGoalSection,
      showPropertySection,
      isPurchaseFlow,
      MORTGAGE_DETAILS_REQUESTED
    };
  }
});